import script from "./StatisticsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./StatisticsPage.vue?vue&type=script&setup=true&lang=ts"

import "./StatisticsPage.vue?vue&type=style&index=0&id=5f5479bc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f5479bc"]])

export default __exports__